import React, { useEffect, memo } from 'react';
import { Form, Select, Input, FormModal, Col, Row } from 'components';

interface RejectModalProps {
  form: any;
  open: boolean;
  loading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  rejectionReasons: { label: string; value: string }[];
}

export const NegotiateModal: React.FC<RejectModalProps> = memo(
  ({ form, open, onSubmit, onCancel, loading, rejectionReasons }) => {
    useEffect(() => {
      if (open) {
        form.resetFields();
      }
    }, [form, open]);

    return (
      <FormModal
        form={form}
        width={400}
        loading={loading}
        title="Negotiate"
        open={open}
        onSubmit={onSubmit}
        onCancel={onCancel}
        disableOkBtn={false}
        okText="Negotiate"
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="negotiatePhase"
              label="Negotiate Phase*"
              rules={[{ required: true, message: 'Please select a rejection phase' }]}
            >
              <Select size={'large'} options={rejectionReasons} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="negotiateInformation" label="Negotiate Information">
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    );
  }
);
